import { atom  } from "recoil";

export const matchIdDataState = atom({
    key : "matchIdDataState",
    default : []
})